import Skeleton from 'react-loading-skeleton';

type TProps = {
  columnCount: number;
  rowCount?: number;
  cellClassName?: string;
};

export const UsersTableSkeleton = ({
  columnCount,
  rowCount = 6,
  cellClassName,
}: TProps) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr key={rowIndex} data-testid="users-table-skeleton-row">
          {Array.from({ length: columnCount }).map((_, columnIndex) => (
            <td key={columnIndex} className={cellClassName}>
              <Skeleton baseColor="var(--color-structure-95)" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
